import { RootState } from 'store/rootReducer';

export const themeValueSelector = (state: RootState) => state.Preferences.theme.contrastMode;

export const themePackSelector = (state: RootState) => state.Preferences.theme.themePack;
